(function () {
    RCDPW.module('RCDPW.validator.rules.administration.ChangeKeyStatus', {
        newStatus: {
            required: true
        },
        comment: {
            optionalComment: true
        }
    });
})();